import * as repairCategories from "./repairCategories";
import i18n from "@/common/lang.serivce";

const RepairCategories = {
  list() {
    return Object.keys(repairCategories);
  },
  getAll() {
    return this.list().map(repairCategory => {
      return {
        value: repairCategory,
        text: i18n.t("repairCategories." + repairCategory)
      };
    });
  }
};

export default RepairCategories;
